import React, { useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Delete, DeleteSweep, PlaylistAddCheck } from "@mui/icons-material";
import DataTableBase from "./dataTableBase";
import { deviceColumns } from "./columnDefs";
import ClearFramesDialog from "../Dialogs/clearFrames";
import DeleteDevicesDialog from "../Dialogs/deleteDevices";

// Shared devices table with an opt-in bulk-select mode (toggled via the
// toolbar icon) for clearing frames and/or deleting devices in bulk.
// Used by the main devices list, an organisation's device list, and a
// brand's device list, so the toggle/dialog wiring only lives here once.
export default function DevicesTableBase({
  devices = [],
  title = "Devices",
  orderby = "time_created",
  orderdirection = "desc",
}) {
  const [selectMode, setSelectMode] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearFramesDialogOpen, setClearFramesDialogOpen] = useState(false);
  const [deleteDevicesDialogOpen, setDeleteDevicesDialogOpen] = useState(false);

  const selectedDevices = selectedRows
    .map((dataIndex) => devices[dataIndex])
    .filter(Boolean);
  const selectedDeviceIds = selectedDevices.map((device) => device.id);
  const selectedDeviceNames = selectedDevices.map(
    (device) => device.name || device.dev_eui,
  );

  const toggleSelectMode = () => {
    setSelectMode((prev) => !prev);
    setSelectedRows([]);
  };

  const closeClearFrames = () => {
    setClearFramesDialogOpen(false);
    setSelectedRows([]);
  };

  const closeDeleteDevices = () => {
    setDeleteDevicesDialogOpen(false);
    setSelectedRows([]);
  };

  return (
    <>
      <DataTableBase
        title={title}
        data={devices}
        columns={deviceColumns}
        orderby={orderby}
        orderdirection={orderdirection}
        selectableRows={selectMode ? "multiple" : "none"}
        rowsSelected={selectedRows}
        onRowsSelect={(curr, allRows) =>
          setSelectedRows(allRows.map((row) => row.dataIndex))
        }
        customToolbar={() => (
          <Tooltip
            title={selectMode ? "Exit selection mode" : "Select devices"}
          >
            <IconButton
              onClick={toggleSelectMode}
              color={selectMode ? "primary" : "default"}
            >
              <PlaylistAddCheck />
            </IconButton>
          </Tooltip>
        )}
        customToolbarSelect={() => (
          <Box sx={{ display: "flex" }}>
            <Tooltip title="Clear frames for selected devices">
              <IconButton onClick={() => setClearFramesDialogOpen(true)}>
                <DeleteSweep />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete selected devices">
              <IconButton onClick={() => setDeleteDevicesDialogOpen(true)}>
                <Delete />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      />
      <ClearFramesDialog
        deviceIds={selectedDeviceIds}
        deviceNames={selectedDeviceNames}
        open={clearFramesDialogOpen}
        handleClose={closeClearFrames}
      />
      <DeleteDevicesDialog
        deviceIds={selectedDeviceIds}
        deviceNames={selectedDeviceNames}
        open={deleteDevicesDialogOpen}
        handleClose={closeDeleteDevices}
      />
    </>
  );
}
